export enum EProducutionStagesType {
	MEAL = 'meal',
	SEMI_PRODUCT = 'semi-product',
	SEMI_PRODUCT_NESTED = 'semi-product-nested',
	SEMI_PRODUCT_INHERITED = 'semi-product-inherited',
	GROUP = 'group',
	INGREDIENT = 'ingredient',
	GROUP_INGREDIENT = 'group-ingredient',
}

export enum EProductionStageWeightType {
	WASTE = 'waste',
	OUTPUT = 'output',
}

export enum EProductionStageDurationType {
	TIME = 'time',
	PERFORMANCE = 'performance',
}

export const BLOCKED_RECIPE_SOCKET_NAMES: string[] = ['PAKOWALNIA']
